import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthGuard, AuthRedirectService, AuthService, SemanticPathService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BonusSystemFeatureAvailableService } from '../services/bonus-system-feature-available.service';

/**
 * Не пускает анонов, если программа лояльности доступна.
 */
@Injectable({
  providedIn: 'root',
})
export class LoyaltyAuthGuard extends AuthGuard {
  constructor(
    protected authService: AuthService,
    protected authRedirectService: AuthRedirectService,
    protected router: Router,
    protected semanticPathService: SemanticPathService,
    private bonusSystemFeatureAvailableService: BonusSystemFeatureAvailableService,
  ) {
    super(authService, authRedirectService, router, semanticPathService);
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.bonusSystemFeatureAvailableService.isFeatureAvailableForBaseStore().pipe(
      switchMap((isFeatureAvailableForBaseStore) => {
        if (!isFeatureAvailableForBaseStore) {
          return of(true);
        }

        return super.canActivate();
      }),
    );
  }
}
